module.exports = "/virtual-football-league/img/amblems/left/logos/FakeWolverhampton.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/FakeWolverhampton.png
// module id = 2074
// module chunks = 4